import _axios from '../../apiClient'


export function getPromociones(id) {

  return _axios.get(`/api/BandaDescuento/Get`,
    {
      params: {id},
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    })
    .then(response => response.data)
    .catch((error) => {
      const data = error.response.data
      throw (data)
    })
}

export function savePromo(promo) {

  return _axios.post(`/api/BandaDescuento/Save`,
  promo,  
  { headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    })
    .then(response => response.data)
    .catch((error) => {
      const data = error.response.data
      throw (data)
    })
}


export function saveImagen(payload) { 
  let recorte = payload.currentFile;
  let original = payload.originalFile;
  let formData = new FormData();
  formData.append('file', recorte);
  formData.append('file', original);

  return _axios.post(`/api/BandaDescuento/SubirImagen`,
  formData,
  {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
  .then(response => response.data)
  .catch((error) => {
    const data = error.response.data
    throw (data)
  })
}


export function getImagen(original) {

  return _axios.get(`/api/BandaDescuento/GetImagen`,
    {
      params: {original},
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    })
    .then(response => response.data)
    .catch((error) => {
      const data = error.response.data
      throw (data)
    })
}

export function eliminarPromocion(id) {

  return _axios.get(`/api/BandaDescuento/Eliminar`,
    {
      params: {id, revertir:false},
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    })
    .then(response => response.data)
    .catch((error) => {
      const data = error.response.data
      throw (data)
    })
}